<div class="flex flex-col gap-5 w-full">

  <!-- Cabeçalho -->
  <div class="bg-white dark:bg-black rounded-xl shadow-sm border border-gray-200 dark:border-zinc-800 px-6 py-4">
    <div class="flex items-center justify-between flex-wrap gap-3">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-full bg-red-50 dark:bg-red-950/40 flex items-center justify-center flex-shrink-0">
          <i class="pi pi-chart-bar text-xl text-[#E41B2E]"></i>
        </div>
        <div>
          <h1 class="text-xl font-bold text-gray-800 dark:text-white leading-tight">Metas de Bonificação</h1>
          <p class="text-sm text-gray-500 dark:text-gray-400">Configure metas e defina quais notificações contribuem</p>
        </div>
      </div>
      <p-button label="Nova Meta" icon="pi pi-plus" (onClick)="abrirNova()" styleClass="btn-red"/>
    </div>
  </div>

  <!-- Lista de metas -->
  @if (loading) {
    <div class="flex flex-col gap-3">
      @for (_ of [1,2]; track $index) {
        <p-skeleton height="6rem" styleClass="rounded-xl"/>
      }
    </div>
  } @else if (metas.length === 0) {
    <div class="bg-white dark:bg-black rounded-xl border border-gray-200 dark:border-zinc-800 p-10 flex flex-col items-center gap-3">
      <i class="pi pi-chart-bar text-4xl text-gray-300 dark:text-zinc-600"></i>
      <p class="text-gray-500 dark:text-gray-400">Nenhuma meta cadastrada</p>
      <p-button label="Criar primeira meta" icon="pi pi-plus" (onClick)="abrirNova()" styleClass="btn-red"/>
    </div>
  } @else {
    <p-table #dt [value]="metas" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]"
             [globalFilterFields]="['nome', 'descricao']" styleClass="p-datatable-sm">
      <ng-template #caption>
        <div class="flex justify-end">
          <p-iconfield iconPosition="left">
            <p-inputicon class="pi pi-search"/>
            <input pInputText type="text" placeholder="Buscar por nome ou descrição"
                   (input)="dt.filterGlobal($any($event.target).value, 'contains')"/>
          </p-iconfield>
        </div>
      </ng-template>
      <ng-template #header>
        <tr>
          <th>Meta</th>
          <th>Tipo</th>
          <th>Valor Alvo</th>
          <th>Período</th>
          <th>Status contribuintes</th>
          <th style="width: 9rem">Ações</th>
        </tr>
      </ng-template>
      <ng-template #body let-meta>
        <tr>
          <td>
            <div class="flex items-center gap-2 flex-wrap">
              <span class="font-semibold text-gray-800 dark:text-white">{{ meta.nome }}</span>
              <p-tag [value]="meta.ativo ? 'Ativa' : 'Inativa'"
                     [severity]="meta.ativo ? 'success' : 'secondary'" styleClass="text-xs"/>
            </div>
            @if (meta.descricao) {
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">{{ meta.descricao }}</p>
            }
          </td>
          <td class="whitespace-nowrap">
            <span class="flex items-center gap-1 text-sm text-gray-600 dark:text-gray-300">
              <i [class]="tipoConfigDe(meta.tipoMeta).icon"></i>
              {{ tipoConfigDe(meta.tipoMeta).label }}
            </span>
          </td>
          <td>{{ meta.valorMeta | metaValor:meta.tipoMeta }}</td>
          <td class="whitespace-nowrap">{{ meta.dataInicio | date:'dd/MM/yyyy' }} – {{ meta.dataFim | date:'dd/MM/yyyy' }}</td>
          <td>
            <span class="flex gap-1 flex-wrap">
              @for (s of meta.statusContribuintes; track s) {
                <span class="bg-red-50 dark:bg-red-950/30 text-[#E41B2E] dark:text-red-400 px-2 py-0.5 rounded-full text-xs font-medium">{{ s }}</span>
              }
            </span>
          </td>
          <td>
            <div class="flex gap-1">
              <p-button icon="pi pi-chart-bar" [text]="true" severity="secondary" (onClick)="visualizarProgresso(meta)" pTooltip="Ver progresso"/>
              <p-button icon="pi pi-pencil" [text]="true" severity="secondary" (onClick)="editar(meta)" pTooltip="Editar"/>
              <p-button icon="pi pi-trash" [text]="true" severity="danger" (onClick)="confirmarExclusao(meta)" pTooltip="Remover"/>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr><td colspan="5" class="text-center text-gray-400 py-4">Nenhuma meta encontrada.</td></tr>
      </ng-template>
    </p-table>
  }

</div>

<p-confirmdialog/>

<!-- Dialog criar/editar -->
<p-dialog [(visible)]="showDialog" [modal]="true" [closable]="true" [draggable]="false"
          [style]="{width: '560px'}" [contentStyle]="{'max-height': '72vh', 'overflow-y': 'auto'}"
          [header]="editingId ? 'Editar Meta' : 'Nova Meta'">
  <p-fluid>
    <form [formGroup]="form" class="flex flex-col gap-4 pt-2">

      <div class="flex flex-col gap-1">
        <label>Nome <span class="required">*</span></label>
        <input pInputText formControlName="nome" placeholder="Ex: Meta de Bonificação 2025" maxlength="100"/>
      </div>

      <div class="flex flex-col gap-1">
        <label>Descrição</label>
        <textarea pTextarea formControlName="descricao" rows="2"
                  placeholder="Descrição opcional da meta"></textarea>
      </div>

      <div class="flex flex-col gap-1">
        <label>Tipo de Meta <span class="required">*</span></label>
        <p-select formControlName="tipoMeta" [options]="tipoMetaOptions" optionLabel="label" optionValue="value" appendTo="body"/>
        <small class="text-gray-500 dark:text-gray-400">{{ tipoConfigAtual.descricaoCurta }}</small>
      </div>

      <div class="flex flex-col gap-1">
        <label>{{ tipoConfigAtual.labelMeta }} <span class="required">*</span></label>
        @if (tipoAtual === 'VALOR') {
          <p-inputnumber formControlName="valorMeta" mode="currency" currency="BRL"
                         locale="pt-BR" placeholder="R$ 0,00"/>
        } @else if (tipoAtual === 'QUANTIDADE') {
          <p-inputnumber formControlName="valorMeta" suffix=" notificações" [min]="0" [maxFractionDigits]="0"/>
        } @else if (tipoAtual === 'MEDIA_DIAS_ABERTO') {
          <p-inputnumber formControlName="valorMeta" suffix=" dias" [min]="0" [maxFractionDigits]="1"/>
        } @else if (tipoAtual === 'PERCENTUAL_STATUS' || tipoAtual === 'TAXA_SAIDA_ENTRADA') {
          <p-inputnumber formControlName="valorMeta" suffix="%" [min]="0" [max]="100" [maxFractionDigits]="1"/>
        } @else {
          <p-inputnumber formControlName="valorMeta" suffix=" processos" [min]="0" [maxFractionDigits]="0"/>
        }
      </div>

      <div class="grid grid-cols-2 gap-3">
        <div class="flex flex-col gap-1">
          <label>Data Início <span class="required">*</span></label>
          <p-datepicker formControlName="dataInicio" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"/>
        </div>
        <div class="flex flex-col gap-1">
          <label>Data Fim <span class="required">*</span></label>
          <p-datepicker formControlName="dataFim" dateFormat="dd/mm/yy" [showIcon]="true" appendTo="body"/>
          @if (form.errors?.['dataFimInvalida'] && form.get('dataFim')?.touched) {
            <small class="text-red-500">A data fim deve ser posterior à data início.</small>
          }
        </div>
      </div>

      <div class="flex flex-col gap-1">
        <label>Status que contribuem para a meta <span class="required">*</span></label>
        <p-multiselect formControlName="statusContribuintes" [options]="statusOptions"
                       optionLabel="label" optionValue="value" appendTo="body"
                       placeholder="Selecione os status" [showClear]="true"
                       display="chip"/>
      </div>

      @if (tipoAtual === 'PERCENTUAL_STATUS') {
        <div class="flex flex-col gap-1">
          <label>Status alvo <span class="required">*</span></label>
          @if (statusAlvoOptions.length === 0) {
            <small class="text-gray-500 dark:text-gray-400">Selecione ao menos um status contribuinte para poder escolher o status alvo.</small>
          } @else {
            <p-select formControlName="statusAlvo" [options]="statusAlvoOptions"
                      optionLabel="label" optionValue="value" appendTo="body"
                      placeholder="Selecione o status alvo"/>
          }
          @if (form.errors?.['statusAlvoInvalido'] && form.get('statusAlvo')?.touched) {
            <small class="text-red-500">Selecione um status alvo entre os status contribuintes.</small>
          }
        </div>
      }

      @if (tipoAtual === 'PROCESSOS_PENDENTES') {
        <div class="flex flex-col gap-1">
          <label>Curso alvo <span class="required">*</span></label>
          <p-select formControlName="cursoAlvo" [options]="cursoOptions"
                    optionLabel="label" optionValue="value" appendTo="body"
                    placeholder="Selecione o curso"/>
          <small class="text-gray-500 dark:text-gray-400">
            Data Fim é usada como data de corte da apuração; os status contribuintes definem quem entra na base.
          </small>
          @if (form.errors?.['cursoAlvoInvalido'] && form.get('cursoAlvo')?.touched) {
            <small class="text-red-500">Selecione um curso alvo.</small>
          }
        </div>
      }

      <div class="flex items-center gap-2">
        <p-checkbox formControlName="ativo" [binary]="true" inputId="ativo"/>
        <label for="ativo" class="cursor-pointer font-normal">Meta ativa</label>
      </div>

    </form>
  </p-fluid>

  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cancelar" [text]="true" severity="secondary" (onClick)="showDialog = false"/>
      <p-button [label]="saving ? 'Salvando...' : 'Salvar'" icon="pi pi-check"
                styleClass="btn-red" (onClick)="salvar()" [loading]="saving"/>
    </div>
  </ng-template>
</p-dialog>

<!-- Prévia de progresso -->
<p-dialog [(visible)]="progressoDialogVisible" [modal]="true" [closable]="true" [draggable]="false"
          [style]="{width: '900px', maxWidth: '95vw'}" [contentStyle]="{'max-height': '80vh', 'overflow-y': 'auto'}"
          header="Progresso da meta">
  @if (progressoLoading) {
    <p-skeleton height="20rem" styleClass="rounded-xl"/>
  } @else if (progressoSelecionado) {
    <app-meta-progresso-panel [progresso]="progressoSelecionado"/>
  }
</p-dialog>
